import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserBank, UserBankPayload } from '../models/bank.model';

@Injectable({
  providedIn: 'root',
})
export class BankApiService {
  private banksUrl: string =
    environment.apiBaseUrl + '/core/portal/profile/banks';

  constructor(private http: HttpClient) {}

  getUserBankList(): Observable<UserBank[]> {
    return this.http.get<UserBank[]>(this.banksUrl);
  }

  createUserBank(bank: UserBankPayload): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/core/bank-account/add`, bank);
    // return this.http.post<any>(this.banksUrl, bank);
  }

  setFavoriteUserBank(bank: UserBank): Observable<any> {
    return this.http.patch<any>(`${this.banksUrl}/${bank.id}`, {});
  }

  deleteUserBank(bankId: number): Observable<any> {
    return this.http.delete<any>(this.banksUrl + '/' + bankId);
  }

  selectCheckAccount(body: any): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/core/bank-account/add-cheque`, body);
  }
}
